module.exports = __webpack_public_path__ + "img/012.c277aaed.jpg";